import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone:false,
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

}
